import axios from "axios";
import qs from "qs";
import { Loading } from "element-ui";

const request = axios.create({
  // Development uses vue.config.js proxy; production uses the /xl-water
  // reverse proxy on cwater.mr-future.com. Keeping both environments
  // same-origin avoids the xl-water server's rejected CORS preflight.
  baseURL: "/xl-water",
  timeout: 30000
});

let loadingInstance = null;

function closeLoading() {
  if (!loadingInstance) {
    return;
  }

  loadingInstance.close();
  loadingInstance = null;
}

request.interceptors.request.use(config => {
  const contentType =
    config.headers["Content-Type"] || config.headers["content-type"];
  if (config.data && contentType === "application/x-www-form-urlencoded") {
    config.data = qs.stringify(config.data, { arrayFormat: "repeat" });
  }

  if (config.loading && !loadingInstance) {
    loadingInstance = Loading.service({
      text: "拼命请求中",
      background: "rgba(0,0,0,0.3)",
      customClass: "LoadingClass"
    });
  }

  delete config.loading;
  return config;
});

request.interceptors.response.use(
  response => {
    closeLoading();
    return response.data;
  },
  error => {
    closeLoading();
    return Promise.reject(error);
  }
);

export default request;
